import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { UhfFooterMode, UhfHeaderMode } from "../models";
import { UhfScope } from "./scopes";
import { UhfState } from "./state";
import { UhfActions, uhfActions } from "./uhfActions";

const initialState: UhfState = {
  headerMode: UhfHeaderMode.Full,
  footerMode: UhfFooterMode.Full,
  isDark: false,
};

export function fetchUhfCompleted(
  state: UhfState,
  action: ReturnType<typeof uhfActions.fetchUhf.success>
): UhfState {
  return {
    ...state,
    data: { ...action.data },
    error: undefined,
  };
}

export function fetchUhfError(state: UhfState): UhfState {
  // retain earlier state and set error metadata
  return {
    ...state,
    error: state.error,
  };
}

export function setHeaderMode(
  state: UhfState,
  action: ReturnType<typeof uhfActions.setHeaderMode>
): UhfState {
  if (action.mode === state.headerMode) {
    return state;
  }

  return {
    ...state,
    headerMode: action.mode,
  };
}

export function resetHeaderMode(state: UhfState): UhfState {
  if (UhfHeaderMode.Full === state.headerMode) {
    return state;
  }

  return {
    ...state,
    headerMode: UhfHeaderMode.Full,
  };
}

export function setFooterMode(
  state: UhfState,
  action: ReturnType<typeof uhfActions.setFooterMode>
): UhfState {
  if (action.mode === state.footerMode) {
    return state;
  }

  return {
    ...state,
    footerMode: action.mode,
  };
}

export function resetFooterMode(state: UhfState): UhfState {
  if (UhfFooterMode.Full === state.footerMode) {
    return state;
  }

  return {
    ...state,
    footerMode: UhfFooterMode.Full,
  };
}

export function setDark(state: UhfState, action: ReturnType<typeof uhfActions.setDark>): UhfState {
  if (action.isDark === state.isDark) {
    return state;
  }

  return {
    ...state,
    isDark: action.isDark,
  };
}

export function resetDark(state: UhfState): UhfState {
  if (!state.isDark) {
    return state;
  }

  return {
    ...state,
    isDark: false,
  };
}

export const uhfReducer = withScope(
  [UhfScope],
  new ReducerChain<UhfState>(initialState)
    .on(UhfActions.FETCH_UHF_COMPLETED, fetchUhfCompleted)
    .on(UhfActions.FETCH_UHF_ERROR, fetchUhfError)
    .on(UhfActions.SET_HEADER_MODE, setHeaderMode)
    .on(UhfActions.RESET_HEADER_MODE, resetHeaderMode)
    .on(UhfActions.SET_FOOTER_MODE, setFooterMode)
    .on(UhfActions.RESET_FOOTER_MODE, resetFooterMode)
    .on(UhfActions.SET_DARK, setDark)
    .on(UhfActions.RESET_DARK, resetDark)
    .build()
);
